import { request } from '@/shared/api/request'

export const postReviewXml = (body) => request({ url: `contract/review/xml`, method: 'POST', data: body })